(() => {
  function update(section) {
    const widget = section.querySelector('[data-purchase-options]');
    if (!widget) return;
    const variantId = section.querySelector('[name="id"]').value;
    widget.querySelectorAll('[data-purchase-variant]').forEach(panel => {
      const active = panel.dataset.purchaseVariant === variantId;
      panel.hidden = !active;
      panel.disabled = !active;
      if (!active) return;
      let choice = panel.querySelector('input:checked');
      if (!choice) { choice = panel.querySelector('input'); if (choice) choice.checked = true; }
      if (!choice) return;
      section.querySelector('[data-product-price]').textContent = choice.dataset.optionPrice;
      const caption = section.querySelector('[data-product-price-caption]');
      if (caption) caption.textContent = choice.dataset.optionCaption;

    });
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[name="selling_plan"], [data-variant-select]')) return;
    const section = event.target.closest('[data-product-section]');
    if (section) update(section);
    if (event.target.name === 'selling_plan') {
      const url = new URL(location.href);
      if (event.target.value) url.searchParams.set('selling_plan', event.target.value);
      else url.searchParams.delete('selling_plan');
      history.replaceState({}, '', url);
    }
  });
  document.querySelectorAll('[data-product-section]').forEach(update);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-product-section]').forEach(update);
  });
})();
